import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot } from "vue";
import { ElMessage } from 'element-plus';
import { onErrorCaptured } from 'vue';
import { ApiError, getErrorMessage } from '@/api';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ErrorBoundary',
    setup(__props) {
        onErrorCaptured((err) => {
            if (err instanceof ApiError) {
                ElMessage.error(getErrorMessage(err));
            }
            throw err;
        });
        return (_ctx, _cache) => {
            return _renderSlot(_ctx.$slots, "default");
        };
    }
});
